module.exports = __webpack_public_path__ + "static/media/Resume_CV.99f4ef7f.pdf";